<template>
  <div>
    <loading v-if="carregando"/>
    <template v-else>
      <div v-if="filtrosTipoAlerta.length > 1" aria-label="Tipo de alerta" class="d-flex flex-wrap mb-2" role="group">
        <button v-for="filtro in filtrosTipoAlerta" :key="String(filtro.valor)" :aria-pressed="tipoAlertaSelecionado === filtro.valor"
                :class="tipoAlertaSelecionado === filtro.valor ? 'btn-primary' : 'btn-outline-dark'"
                class="btn btn-sm mr-2 mb-2 filtro-tipo-alerta"
                type="button"
                @click="tipoAlertaSelecionado = tipoAlertaSelecionado === filtro.valor ? '' : filtro.valor">
          {{ filtro.label }}
          <span :class="tipoAlertaSelecionado === filtro.valor ? 'badge-light' : 'badge-dark'"
                class="badge ml-1">{{ filtro.quantidade }}</span>
        </button>
      </div>
      <alerta-grupo-ocorrencias v-if="alertasOcorrencias.length" :alertas="alertasOcorrencias"
                                 @ignorar="$emit('ignorar-grupo', $event)" @ver-pedido="$emit('ver-pedido', $event)"/>
      <alerta-item v-for="alerta in alertasInterativos" :key="alerta.id" :alerta="alerta"
                   @ignorar="$emit('ignorar', $event)" @responder="$emit('responder', $event)" @ver-pedido="$emit('ver-pedido', $event)"/>
      <div v-if="!alertas.length" class="text-center mt-5">
        <i aria-hidden="true" class="fas fa-check-circle fa-2x text-muted d-block mb-3"></i>
        Tudo certo por aqui!
      </div>
      <div v-else-if="!alertasFiltrados.length" class="text-center mt-4">Nenhum alerta deste tipo.</div>
    </template>
  </div>
</template>

<script>
import Loading from '@/components/commons/Loading';
import AlertaItem from './AlertaItem';
import AlertaGrupoOcorrencias from './AlertaGrupoOcorrencias';

export default {
  name: 'Alertas',
  components: { Loading, AlertaItem, AlertaGrupoOcorrencias },
  props: {
    aberto: { type: Boolean, default: false },
    alertas: { type: Array, default: () => [] },
    carregando: { type: Boolean, default: false }
  },
  data() {
    return { tipoAlertaSelecionado: '' };
  },
  methods: {
    selecionarTipo(tipo) {
      this.tipoAlertaSelecionado = this.filtrosTipoAlerta.length > 1
        && this.filtrosTipoAlerta.some(filtro => filtro.valor === tipo) ? tipo : '';
    }
  },
  computed: {
    filtrosTipoAlerta() {
      return [
        { valor: 1, label: 'Cancelamentos' },
        { valor: 2, label: 'Solicitações' },
        { valor: 3, label: 'Logística' }
      ].map(filtro => ({
        ...filtro,
        quantidade: this.alertas.filter(alerta => alerta.tipo === filtro.valor).length
      })).filter(filtro => filtro.quantidade > 0);
    },
    alertasFiltrados() {
      return this.filtrosTipoAlerta.length <= 1 || this.tipoAlertaSelecionado === ''
        ? this.alertas
        : this.alertas.filter(alerta => alerta.tipo === this.tipoAlertaSelecionado);
    },
    alertasOcorrencias() { return this.alertasFiltrados.filter(alerta => alerta.tipo === 1); },
    alertasInterativos() { return this.alertasFiltrados.filter(alerta => alerta.tipo !== 1); }
  },
  watch: {
    aberto(valor) {
      if (!valor) this.tipoAlertaSelecionado = '';
    },
    filtrosTipoAlerta(filtros) {
      if (filtros.length <= 1 || !filtros.some(filtro => filtro.valor === this.tipoAlertaSelecionado)) {
        this.tipoAlertaSelecionado = '';
      }
    }
  }
};
</script>

<style scoped>
.filtro-tipo-alerta { min-width: 130px; }
.filtro-tipo-alerta .badge { min-width: 16px; }
</style>
